export const tips = [
    "You earn gold while queuing for a match. Patience pays off!",
    "Teaching a spell to a character permanently consumes it - choose carefully!",
    "Play Casual or Ranked games for daily chest keys!",
    "Level-ups grant your characters SP - spend them on their stats to make them stronger!",
    "If your mages often lack MP, equip them with Ethers!",
    "The Poison spell deals damage over time to an enemy!",
    "Fire spells set the ground on fire, dealing damage to characters standing on or crossing it!",
    "Ice spells freeze characters, preventing them from moving or attacking until freed!",
    "Free frozen character by attacking them with a melee attack or a fire spell!",
    "Thunder spells paralyze characters, preventing them from moving or attacking for several turns!",
    "The + and X versions of spells tend to have larger areas of effect and deal more damage!",
    "The order of your characters' turns is determined by their speed stat.",
    "Ice spells on empty tiles create path-blocking ice blocks",
    "HP and MP are fully restored after each combat.",
    "Use Clovers to revive characters in combat.",
    // "The bar at the bottom of the game screen is the Audience bar. Impress the audience to earn extra rewards!",
    "Challenge players using the Challenge button on their profile page.",
    "Buy Antidotes to counter Poison.",
    "Buy Boccas to counter Silence.",
    "The Silence spell prevents a character from casting spells for several turns.",
    "The Revive spell can be used to revive a single target.",
];

export const guide = [
    "You have a lot of gold, champion! Click here to go to the shop and buy something nice for your characters!",
    "One of your characters has unspent SP! Click here to go to the team page and spend them to increase their stats!",
    "A key for one of your daily loot chests is ready to be won! Click here to start a Casual game and win it!",
    "You have unused equipment pieces in your inventory! Click here to go to the team page and equip them!",
    "You have unused consumables in your inventory! Click here to go to the team page and equip them on your characters!",
    "You have unused spells in your inventory! Click here to go to the team page and teach them to your characters!",
    "Not sure what to do? Just click here to start a Practice game and try out your characters and spells!",
    "Now that you know the game a bit more, click here to play against another player in Casual mode!",
    "You've had a few victories now, why don't you try your luck in Ranked mode and climb the ladder? Click here to start!",
    "Your characters know cool spells, why don't you give them a try in combat?",
];